import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { MobileProvider } from './providers/mobile-provider';
import AudioInitializer from "./components/audio-initializer";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration, replayIntegration } from "@sentry/react";

// Initialize Sentry
Sentry.init({
  dsn: "https://1440a52ebbde8c5ef14f72ce040d1741@o4509264241557504.ingest.de.sentry.io/4509264292347984",
  integrations: [
    // Use browserTracingIntegration function instead of BrowserTracing constructor
    browserTracingIntegration({
      // Set a uniform sample rate for all transactions
      tracesSampleRate: 0.2,
    }),
    // Use replayIntegration function instead of Replay constructor
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance monitoring - adjust as needed
  tracesSampleRate: 0.2,
  // Session replay - adjust as needed
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(
  <MobileProvider>
    <AudioInitializer />
    <App />
  </MobileProvider>
);
